import React from "react";
import Twitter from "../assets/images/icons/icons8-twitter.png";
import Instagram from "../assets/images/icons/icons8-instagram.png";
import Linkedin from "../assets/images/icons/icons8-linkedin.png";
import Youtube from "../assets/images/icons/icons8-youtube.png";
import { Link } from "react-router-dom";
import sitedata from '../sitedetails.json'

const SocialMedia = () => {
  return (
    <div className="font-outfit h-full lg:w-[500px] py-4 mx-auto">
      <div className="justify-center gap-6 items-center flex">
        <Link target={"_blank"} to={sitedata.social_media.twitter}>
          <img className="transition hover:scale-110 hover:-translate-y-2 ease-in-out duration-200 " src={Twitter} width={"30px"} alt="" />
        </Link>
        <Link target={"_blank"} to={sitedata.social_media.instagram}>
          <img className="transition hover:scale-110 hover:-translate-y-2 ease-in-out duration-200 " src={Instagram} width={"30px"} alt="" />
        </Link>

        <Link target={"_blank"} to={sitedata.social_media.linkedin}>
          <img className="transition hover:scale-110 hover:-translate-y-2 ease-in-out duration-200 "  src={Linkedin} width={"30px"} alt="" />
        </Link>

        <Link target={"_blank"} to={sitedata.social_media.youtube}>
          <img className="transition hover:scale-110 hover:-translate-y-2 ease-in-out duration-200 "  src={Youtube} width={"30px"} alt="" />
        </Link>
      </div>
    </div>
  );
};

export default SocialMedia;
